import { useEffect } from 'react';
import { withRouter } from 'react-router';
import RouterPropTypes from 'react-router-prop-types';

import { applyBrowserSentryTags } from '../../../sentry';

/**
 * Keeps Sentry `page_path` (and `site`) in sync with React Router navigations.
 */
export function SentryRouteTags({ history, location }) {
  useEffect(() => {
    const applyFromLocation = (nextLocation) => {
      applyBrowserSentryTags({
        hostname: window.location.hostname,
        pathname: nextLocation.pathname,
      });
    };

    applyFromLocation(location);
    return history.listen(applyFromLocation);
    // Mount/unmount only: listen covers later navigations; re-running on every
    // location change would resubscribe unnecessarily.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return null;
}

SentryRouteTags.propTypes = {
  history: RouterPropTypes.history.isRequired,
  location: RouterPropTypes.location.isRequired,
};

export default withRouter(SentryRouteTags);
